import { Component, ViewChild } from '@angular/core';
import { Subscription ,  Observable ,  BehaviorSubject } from 'rxjs';

import * as _ from 'lodash';

import { BrandService } from '../brand/brand.service';

import { SearchService } from '../search/search.service';
import { SearchModel } from '../search/search.model';
import { SortModel } from '../search/sort.model';
import { ActiveFilterModel } from '../search/active-filters/active-filter.model';
import { SearchFormComponent } from '../search/search-form/search-form.component';
import {debounceTime} from 'rxjs/operators';
import {Config} from 'shared/config/env.config';


@Component({
  template: '',
})
export class SearchWidgetComponent {

  @ViewChild(SearchFormComponent, {static: false}) searchForm: SearchFormComponent;

  searchResultsColumns: Array<any> = [];
  rowsHover: boolean = true;

  searchModel: SearchModel;
  _searchModel: BehaviorSubject<SearchModel>;
  searchModelObservable: Observable<SearchModel>;
  searchModelSub: Subscription;

  constructor(
    protected brandService: BrandService,
    public searchService: SearchService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/
  get allSelected(): boolean {
    return this.searchService.allSelected;
  }
  get currentPage(): number {
    return this.searchModel.currentPage;
  }
  get selectAll(): string {
    return this.searchModel.selectAll;
  }
  get itemsPerPage(): number {
    return this.searchModel.itemsPerPage;
  }
  get currentSortModel(): SortModel {
    return this.searchModel.sortModel;
  }
  get searchResults(): Array<any> {
    return this.searchService.searchResults;
  }
  get selectedRows(): Array<any> {
    return this.searchService.selectedItems;
  }
  get selectedIds(): Array<any> {
    return this.searchService.selectedIds;
  }
  get searchValue(): string {
    return this.searchModel.searchValue;
  }
  get searchModelFilters(): Array<any> {
    return this.searchModel.filters;
  }
  get totalRecords(): number {
    return this.searchService.totalRecords;
  }
  get totalRowsSelected(): number {
    return this.searchService.selectedItemsCount();
  }
  get lastPage(): number {
    return this.searchModel.lastPage;
  }
  get selectedAllChecked(): boolean  {
    return this.searchService.isCurrentPageSelectAllChecked();
  }
  get hasSearchFilters(): boolean  {
    return (!!this.searchValue || !!this.searchModelFilters.length);
  }
  get selectedRowsIds(): Array<any> {
    return _.map(this.selectedRows, this.searchService.idField);
  }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onCheckboxChanged(item: any) {
    if (item.selected) {
      this.searchService.pushSelectedItem(item);
    } else {
      this.searchService.pullSelectedItem(item);
    }

    if (this.searchService.selectedItems.length === 0) {
      this.searchService.allSelected = false;
    }
  }

  onItemsPerPageChange(itemsPerPage: number) {
    this.searchModel.currentPage = 1;
    this.searchModel.itemsPerPage = itemsPerPage;
    this._searchModel.next(this.searchModel);
  }

  onPageChange(page: number) {
    this.searchModel.currentPage = page;
    this._searchModel.next(this.searchModel);
  }

  onSearchValueChanged(searchValue: string) {
    this.searchModel.searchValue = searchValue;
    this.searchModel.currentPage = 1;
    this.searchService.allSelected = false;
    this._searchModel.next(this.searchModel);
  }

  onSortChanged(sortModel: SortModel) {
    this.searchModel.currentPage = 1;
    this.searchModel.sortModel = sortModel;
    this._searchModel.next(this.searchModel);
  }

  onSelectAllClick(select: string) {
    if (select === 'deselect-all') {
      this.searchService.searchModel.selectAll = 'on-page';
      this.searchService.deselectAll();
    } else {
      this.searchService.searchModel.selectAll = select;
      this.searchService.selectAll(true);
    }
  }

  onSelectAllChange(isSelected: boolean) {
    this.searchService.searchModel.selectAll = 'on-page';
    this.searchService.selectAll(isSelected);
  }

  onClearSearchClick() {
    // leave only scorecard filter
    _.remove(this.searchModel.filters, (filter: any) => {
      return filter._id !== 'scorecardId';
    });
    // create new array so Angular recognize this change.
    // ngOnChanges will be called
    this.searchModel.filters = this.searchModel.filters.slice();
    this.searchModel.searchValue = '';
    if (this.searchForm) {
      this.searchForm.resetValue();
    }
    this._searchModel.next(this.searchModel);
  }

  onFilterRemove(filter: ActiveFilterModel) {
    this._searchModel.next(this.searchModel);
  }

  onSearchPreviewClick(toggleForm: boolean) {
    this.searchService.toggleForm(true);
  }

  /*******************************************
   * COMPONENT METHODS
   *******************************************/

  initSubscriptions() {
    this.searchModelSub = this.subscribeSearchModel();
  }

  destroySubscriptions() {
    if (this.searchModelSub) {    this.searchModelSub.unsubscribe(); }
  }

  subscribeSearchModel(): Subscription {
    this._searchModel = <BehaviorSubject<SearchModel>>new BehaviorSubject(this.searchModel);
    this.searchModelObservable = this._searchModel.asObservable();

    return this.searchModelObservable
      .pipe(debounceTime(900))
      .subscribe((searchModel) => {
        this.runSearch(searchModel);
      });
  }

  runSearch(searchModel: SearchModel) {
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .subscribe();
  }
}
